import { useState, useEffect } from 'react';
import { images } from '../../assets';

const Navbar = () => {
  const [showNav, setShowNav] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 50) {
        setShowNav(true);
      } else if (currentScrollY > lastScrollY) {
        setShowNav(false);
      } else {
        setShowNav(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', controlNavbar);
    return () => window.removeEventListener('scroll', controlNavbar);
  }, [lastScrollY]);

  const navLinks = [
    { href: '#', text: 'INICIO' },
    { href: '#about', text: 'NOSOTROS' },
    { href: '#tarifas', text: 'HORARIOS' },
    { href: '#resultados', text: 'RESULTADOS' },
    { href: '#faq', text: 'FAQ' },
    { href: '#contacto', text: 'CONTACTOS' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ${showNav ? 'translate-y-0' : '-translate-y-full'
      } ${lastScrollY > 50 ? 'bg-black/80 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
      <div className="container mx-auto px-6 py-6">
        <div className="flex justify-between items-center gap-4">
          <div className="flex items-center space-x-3 flex-shrink-0">
            <img src={images.logo_gym} alt="Logo de Energy" className="h-10 opacity-70 ml-2" />
            <span className="bebas-font text-lg md:text-2xl text-white tracking-widest">ENERGY</span>
          </div>

          <div className="bebas-font tracking-wider hidden md:flex space-x-14 md:space-x-8 lg:space-x-20 text-2xl md:text-xl lg:text-xl items-center flex-grow justify-center">
            {navLinks.map(link => (
              <a key={link.href} href={link.href} className="hover:text-blue-600 transition-colors whitespace-nowrap">
                {link.text}
              </a>
            ))}
          </div>


        </div>
      </div>
    </nav>
  );
};

export default Navbar;
